import { Component, ChangeDetectionStrategy } from '@angular/core';
import {FlexModule} from "@ngbracket/ngx-layout";

@Component({
  selector: 'app-footer',
  imports: [
    FlexModule
  ],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

}
